export const HOURS = [
  '1:00 am',
  '2:00 am',
  '3:00 am',
  '4:00 am',
  '5:00 am',
  '6:00 am',
  '7:00 am',
  '8:00 am',
  '9:00 am',
  '10:00 am',
  '11:00 am',
  '12:00 pm',
  '1:00 pm',
  '2:00 pm',
  '3:00 pm',
  '4:00 pm',
  '5:00 pm',
  '6:00 pm',
  '7:00 pm',
  '8:00 pm',
  '9:00 pm',
  '10:00 pm',
  '11:00 pm',
];
export const START_OF_DAY = 3;
export const END_OF_DAY = 23;
export const BRAND_TRANSACTIONS = 'brandTransactions';
export const USER_TRANSACTIONS = 'userTransactions';
export const TRANSACTIONS_PAGE_SIZE = 30;
export const CASHBACKS_PAGE_SIZE = 30;
export const LIST_SKELETON_HEIGHT = 15;
export const LIST_SKELETON_WIDTH = 500;
export const ONE_LINE_SKELETON_WIDTH = 400;
export const THUMBNAIL_DEFAULT_WIDTH = 300;
export const THUMBNAIL_DEFAULT_HEIGHT = 300;
export const MAX_DISPLAYED_THUMBNAILS_NUMBER = 4;
export const INITIAL_INDEX = 0;
export const STORE_DEFAULT = 'Nebraska Crossing'
